import swipers from "@/modules/swipers.js";
import Alpine from "alpinejs";
// import {Calendar} from 'vanilla-calendar-pro';

import rangeCalendar from './../modules/rangeCalendar.js';

// const roomsFilterWrapper = document.getElementById('room-inner-filter');

const shortTermRoomsTab = document.getElementById('short-term-room-tab');
const longTermRoomsTab = document.getElementById('long-term-room-tab');

const shortFilterRooms = document.querySelector('.js-short-filter');
const longFilterRooms = document.querySelector('.js-long-filter');

const filterSeasonsWrapper = document.getElementById('filterSeasonsWrapper');
const filterSeasonCheckboxes = document.querySelectorAll('#filterSeasonsWrapper .filter-checkbox');

const shortTermCalendarWrapper = document.getElementById('shortTermCalendarWrapper');

//ROOMS FILTER POP UP ITEMS:
const roomsSelectPopup = document.getElementById('roomsSelectPopup');
const closeSelectPopupButton = document.getElementById('closeSelectPopup');
const roomsSelectPopupTriggers = document.querySelectorAll('.js-select-popup-trigger');
const longTermCheckbox = document.getElementById('long-term-rent');
const shortTermCheckbox = document.getElementById('short-term-rent');

const popupSeasonsList = document.getElementById('popupSeasonsList');
const shortTermRangeSelection = document.getElementById('shortTermRangeSelection');

const roomsPage = document.querySelector('body.page-template-template-rooms');


const homeURL = ajaxObject.homeUrl;

let lastSelectedSeason = '';
let isLoading = false;


const MIN_NIGHTS = shortTermSettings.min_nights;




if (roomsPage) {
    const urlParams = new URLSearchParams(window.location.search)
    const hasSeasonParam = urlParams.has('season');
    const hash = window.location.hash;


    if (hasSeasonParam) {
        lastSelectedSeason = urlParams.get('season');
    } else {
        console.log(filterSeasonCheckboxes)
        // if season is empty preselect first season
        // And preselect first season for long term
        if (filterSeasonCheckboxes.length > 0) {
            const firstSeasons = filterSeasonCheckboxes[0];
            filterSeasonCheckboxes[0].checked = true;
            lastSelectedSeason = firstSeasons.value;

            //preload long term rooms
            const data = new FormData();
            data.append('action', 'load_rooms');
            data.append('season', lastSelectedSeason);
            data.append('nonce', ajaxObject.nonce);
            isLoading = true;

            fetchLongTermRooms(data)
        }
    }

    if (!hasSeasonParam && hash !== '#short') {
        showRoomsSelectPopup()
    }
}



//POPUP term selection and actions:
//Show seasons only if long term is selected
// if (longTermCheckbox) {
//     longTermCheckbox.addEventListener('change', () => {
//         if (longTermCheckbox.checked) {
//             popupSeasonsList.classList.remove('hidden')
//         } else {
//             popupSeasonsList.classList.add('hidden')
//         }
//     })
// }

// Selects correct filtering if triggered from header.
roomsSelectPopupTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault()

        if (trigger.classList.contains('js-long-term')) {
            longTermCheckbox.checked = true;
            longTermCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
        }


        if (trigger.classList.contains('js-short-term')) {
            shortTermCheckbox.checked = true;
            shortTermCheckbox.dispatchEvent(new Event('change', { bubbles: true }))
        }

        showRoomsSelectPopup()
    })
})


// Room stay term selection
// TODO: add if statement so this doesnt break POLISH sites, or add somekind of checkbox from WP to toggle this;
document.addEventListener('change', function(event) {

    console.log('changed')

    if (event.target.name === 'term-option') {
        const selectedValue = event.target.value;

        showTermTab(selectedValue)
    }





});

function showTermTab(term){
    switch (term){
        case 'short-term':
            popupSeasonsList.classList.add('hidden');
            shortTermRangeSelection.classList.remove('hidden');
            break;
        case 'long-term':
            popupSeasonsList.classList.remove('hidden');
            shortTermRangeSelection.classList.add('hidden');
            break;
        default:
            console.warn('Unknown term:', term);
    }
}

// CLOSE POPUP
closeSelectPopupButton.addEventListener('click', () => {
    roomsSelectPopup.classList.add('hidden');
    document.documentElement.classList.remove('no-scroll');
})

function showRoomsSelectPopup() {
    roomsSelectPopup.classList.remove('hidden');
    document.documentElement.classList.add('no-scroll');
    console.log('click???')
}

window.addEventListener('invalidSeason', () => {
    // console.log('event received')
    showRoomsSelectPopup();
    document.documentElement.classList.add('no-scroll');
});

if (longFilterRooms) {
    longFilterRooms.addEventListener('click', () => {

        //TODO: remove date_from and date_to params if active

        window.location.hash = 'long';

        if (lastSelectedSeason !== '') {
            const url = new URL(window.location.href);
            url.searchParams.set('season', lastSelectedSeason);
            history.replaceState({}, '', url.toString());
        }

        shortFilterRooms.classList.remove('active');
        longFilterRooms.classList.add('active');

        filterSeasonsWrapper.classList.remove('hidden');

        shortTermRoomsTab.classList.add('hidden');
        longTermRoomsTab.classList.remove('hidden');

        shortTermCalendarWrapper.classList.add('hidden')


    });
}



const dateFromButtonRoom = document.querySelector('#date-from-trigger-rooms');
const dateToButtonRoom = document.querySelector('#date-to-trigger-rooms');

const roomsCalendar = document.getElementById('calendar_rooms');
let rooms_calendar;
const shortRoomsContainer = document.getElementById('short-rooms-container');

if (roomsCalendar){


    let params = new URLSearchParams(document.location.search);
    let date_from = params.get("date_from");
    let date_to = params.get("date_to");


    console.log(date_from, date_to)
    rooms_calendar = rangeCalendar({
        selector: '#calendar_rooms',
        dateFromButton: dateFromButtonRoom,
        dateToButton: dateToButtonRoom,
        calendarOptions: {
            selectedDates: [date_from, date_to],

        },
        onBothDatesSelected: (selectedDates) => {
            rooms_calendar.hide()
            if (roomsPage) {
                console.log('fetch init');

                const data = new FormData();
                data.append('action', 'get_short_rooms');
                data.append('date_from', selectedDates[0]);
                data.append('date_to', selectedDates[1]);
                data.append('nonce', ajaxObject.nonce);

                shortRoomsContainer.style.display = 'none';
                roomsLoader.style.display = 'flex';

                fetchShortTermRooms(data)

                const url = new URL(window.location.href);
                url.searchParams.set('date_from', selectedDates[0]);
                url.searchParams.set('date_to', selectedDates[1]);
                history.replaceState({}, '', url.toString());
                // TODO:
                // If min range correct toggle URL;
                // Fetch function
                // Hide calendar

            }
        }
    });

    rooms_calendar.init();
}


function fetchShortTermRooms(data) {
    fetch(ajaxObject.ajax_url, {
        method: "POST",
        body: data
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            console.log(response);
            shortRoomsContainer.innerHTML = '';
            shortRoomsContainer.innerHTML = response.html;
            shortRoomsContainer.style.display = 'grid';
            roomsLoader.style.display = 'none';
            // isLoading = false;
            swipers();

        })
        .catch(error => {
            console.error(error);
        });
}



if (shortFilterRooms) {
    shortFilterRooms.addEventListener('click', (event) => {

        window.location.hash = 'short';

        //TODO: remove season param if active | do i need to remove?

        let params = new URLSearchParams(document.location.search);
        let date_from = params.get("date_from");
        let date_to = params.get("date_to");

        const season = params.get('season');

        shortTermCalendarWrapper.classList.remove('hidden')

        if (season){
            console.log('season is in url')
        }else{
            console.log('season is not in url')
        }
        console.log('date_from ', date_from)
        console.log('date_to ', date_to)

        //TODO I dont need to clean url here.

        // const cleanUrl = window.location.origin + window.location.pathname + '#short';
        // window.history.replaceState({}, document.title, cleanUrl);

        shortFilterRooms.classList.add('active');
        longFilterRooms.classList.remove('active');

        shortTermRoomsTab.classList.remove('hidden');
        longTermRoomsTab.classList.add('hidden');

        filterSeasonsWrapper.classList.add('hidden');

        // filterCheckboxes.forEach(checkbox=>{
        //     checkbox.checked = false;
        // })

        const dateFromSpan = dateFromButtonRoom.querySelector('span');
        const dateToSpan = dateToButtonRoom.querySelector('span');

        if (date_from !== null && date_to !== null){
            dateFromSpan.textContent = date_from;
            dateToSpan.textContent = date_to;
        }

    });
}

const roomsFilterWrapper = document.getElementById('roomsFilterWrapper');
const filterCheckboxes = document.querySelectorAll('.filter-checkbox');

const roomsLoader = document.getElementById('rooms-loader');
const roomsContainer = document.getElementById('rooms-container');


if (roomsFilterWrapper) {

    roomsFilterWrapper.addEventListener('click', (e) => {
        if (isLoading) {
            e.preventDefault();
            return;
        }
    }, true)


    roomsFilterWrapper.addEventListener('change', (e) => {

        if (isLoading) {
            e.preventDefault();
            return;
        }

        // Check if the changed element is actually a radio button
        e.preventDefault();
        if (e.target.type === 'checkbox') {

            const seasonId = e.target.value;

            if (!e.target.checked) {
                e.target.checked = true;
                console.log('same checkbox')
                return;
            }

            // shortTermRoomsTab.classList.add('hidden');
            // longTermRoomsTab.classList.remove('hidden');

            filterCheckboxes.forEach(checkbox => {

                if (checkbox.value !== seasonId) {
                    checkbox.checked = false;
                }
            })

            roomsContainer.style.display = 'none';
            roomsLoader.style.display = 'flex';

            const data = new FormData();

            data.append('action', 'load_rooms');
            data.append('season', seasonId);
            data.append('nonce', ajaxObject.nonce);
            isLoading = true;

            fetchLongTermRooms(data);

            // Update URL
            const url = new URL(window.location.href);
            url.searchParams.set('season', seasonId);
            history.replaceState({}, '', url.toString());

        }
    });
}


function fetchLongTermRooms(data) {
    fetch(ajaxObject.ajax_url, {
        method: "POST",
        // credentials: 'same-origin',
        body: data
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            console.log(response);
            roomsContainer.innerHTML = response.data.html;
            roomsContainer.style.display = 'grid';
            roomsLoader.style.display = 'none';
            isLoading = false;
            swipers();

        })
        .catch(error => {
            console.error(error);
        });
}

// document.addEventListener('alpine:initialized', () => {
//     // Now try your function
//     function yourFunction() {
//         console.log('Store value:', Alpine.store('appState'));
//     }
//
//     // Test the function
//     yourFunction();
// });

// document.addEventListener('alpine:initialized', () => {
//     // Small timeout to ensure the component is mounted
//     setTimeout(() => {
//         const element = document.querySelector('[x-data="app"]');
//         if (element) {
//             const appData = Alpine.$data(element);
//             console.log(appData.menuOpen); // Should now show your data
//
//             // menuOpen: false,
//             // openlightbox: false,
//             // buttonSwitcher: false,
//
//
//         }
//     }, 0);
// });



const dateFromButton = document.querySelector('#date-from-trigger');
const dateToButton = document.querySelector('#date-to-trigger');


const popupCalendar = rangeCalendar({
    selector: '#calendar',
    dateFromButton: dateFromButton,
    dateToButton: dateToButton,
    calendarOptions: {
        inputMode: false,
    },
    onBothDatesSelected: (selectedDates) => {
        const baseUrl = homeURL;
        const params = new URLSearchParams();
        params.append('date_from', selectedDates[0]);
        params.append('date_to', selectedDates[1]);
        const fullUrl = `${baseUrl}/rooms/?${params.toString()}#short`;
        window.location.href = fullUrl;
    }
});

popupCalendar.init()

// const calendar = new Calendar('#calendar', {
//     selectedTheme: 'light',
//     type: 'multiple',
//     displayMonthsCount: 2,
//     monthsToSwitch: 1,
//     selectionDatesMode: 'multiple-ranged',
//     displayDatesOutside: false,
//     positionToInput: 'left',
//     inputMode: true,
//     dateMin: 'today',
//
//
//     onClickDate(self, event) {
//         // console.log('self ', self)
//         // console.log('event ', event)
//         console.log(self);
//         updateButtonDates(self.context.selectedDates, dateFromButton, dateToButton)
//         resetDisabledDays()
//         if (self.context.selectedDates[0] && !self.context.selectedDates[1]) {
//             const currentDay = new Date(self.context.selectedDates[0])
//             createDisabledDates(currentDay)
//         }
//
//
//         if (self.context.selectedDates[0] && self.context.selectedDates[1]){
//             console.log('both dates selected')
//
//             console.log(homeURL)
//
//             const baseUrl = homeURL;
//
//             // Create URL parameters
//             const params = new URLSearchParams();
//             params.append('date_from', self.context.selectedDates[0]);
//             params.append('date_to', self.context.selectedDates[1]);
//
//             // Combine into full URL string
//             const fullUrl = `${baseUrl}/rooms/?${params.toString()}#short`;
//             console.log(fullUrl);
//
//             window.location.href = fullUrl;
//
//         }else{
//             console.log('NOT both dates selected')
//
//
//         }
//
//     },
//
// });
// calendar.init();

//
dateFromButton.addEventListener('click', ()=>{

    // calendar.show()
    homeCalendar.show()

    const vc = document.querySelector('[data-vc="calendar"]')
    // console.log(vc)
    setTimeout(()=>{
        vc.focus();
    },10)
})


// function updateButtonDates(datesArray, buttonFrom, buttonTo) {
//
//     const checkInButtonText = buttonFrom.querySelector('span');
//     const checkOutButtonText = buttonTo.querySelector('span');
//
//     if (datesArray[0]) {
//         checkInButtonText.innerText = datesArray[0];
//     } else {
//         checkInButtonText.innerText = 'Check in';
//     }
//
//     if (datesArray[1]) {
//         checkOutButtonText.innerText = datesArray[1];
//     } else {
//         checkOutButtonText.innerText = 'Check out'
//     }
// }
//
// function createDisabledDates(currentDay) {
//
//     const nextDay = new Date(currentDay);
//     nextDay.setDate(currentDay.getDate() + 1);
//
//     const minEndDate = new Date(currentDay);
//     minEndDate.setDate(currentDay.getDate() + MIN_NIGHTS - 1); // -1 since min Date should be selectable.
//
//     console.log(minEndDate)
//     console.log(nextDay)
//
//
//     for (let i = 1; i < MIN_NIGHTS; i++) {
//         const targetDateForward = new Date(currentDay);
//         targetDateForward.setDate(currentDay.getDate() + i);
//
//         const targetDateBackward = new Date(currentDay);
//         targetDateBackward.setDate(currentDay.getDate() - i);
//
//         const dateStringForward = targetDateForward.toISOString().split('T')[0];
//         const forwardDatesDivs = document.querySelectorAll(`div[data-vc-date="${dateStringForward}"]`);
//
//         const dateStringBackward = targetDateBackward.toISOString().split('T')[0];
//         const backwardDatesDivs = document.querySelectorAll(`div[data-vc-date="${dateStringBackward}"]`);
//
//
//         console.log(dateStringForward)
//         console.log(forwardDatesDivs)
//
//         forwardDatesDivs.forEach(dateElement=>{
//             setDateAsDisabled(dateElement)
//         })
//
//         backwardDatesDivs.forEach(dateElement=>{
//             setDateAsDisabled(dateElement)
//         })
//     }
// }
//
// function setDateAsDisabled(dateElement){
//     dateElement.classList.add('disabled');
//     dateElement.style.pointerEvents = 'none';
//     dateElement.tabIndex = -1;
//
//     const button = dateElement.querySelector('.vc-date__btn');
//     if (button) {
//         button.classList.add('disabled');
//         button.style.pointerEvents = 'none';
//         button.setAttribute('tabindex', '-1');
//         console.log(button.tabIndex)
//         button.disabled = true;
//     }
// }
//
// function resetDisabledDays(){
//     const disabledDates = document.querySelectorAll('div[data-vc-date].disabled');
//     console.log(disabledDates)
//
//     disabledDates.forEach(disabledDate=>{
//         disabledDate.classList.remove('disabled');
//         disabledDate.style.pointerEvents = 'auto';
//
//         const button = disabledDate.querySelector('.vc-date__btn');
//         if (button) {
//             button.classList.remove('disabled');
//             button.style.pointerEvents = 'auto';
//             button.removeAttribute('tabindex');
//             button.disabled = false;
//         }
//
//     })
// }

// TODO: if rooms page and url has date_from and date_to params populate and setup calendar and buttons with those dates.


// <div className="vc-date" data-vc-date="2025-08-01" data-vc-date-month="current" data-vc-date-week-day="5">
//     <button className="vc-date__btn" type="button" role="gridcell" aria-label="August 1, 2025" data-vc-date-btn="">1
//     </button>
// </div>